import React from 'react';
import { useMousePosition } from '../../hooks/useMousePosition';

/**
 * AnimatedBackground - Animated gradient orbs with parallax effect
 * Provides visual depth and motion without heavy performance cost
 */
const AnimatedBackground = () => {
  const mousePosition = useMousePosition();

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      {/* Gradient Orbs with Parallax */}
      <div
        className="absolute w-96 h-96 rounded-full opacity-20 blur-3xl transition-transform duration-1000"
        style={{
          background: 'radial-gradient(circle, var(--color-accent) 0%, transparent 70%)',
          transform: `translate(${mousePosition.x * 0.02}px, ${mousePosition.y * 0.02}px)`,
          top: '10%',
          left: '10%'
        }}
      />
      <div
        className="absolute w-80 h-80 rounded-full opacity-15 blur-3xl transition-transform duration-1000"
        style={{
          background: 'radial-gradient(circle, var(--color-accent-alt) 0%, transparent 70%)',
          transform: `translate(${mousePosition.x * -0.015}px, ${mousePosition.y * -0.015}px)`,
          bottom: '20%',
          right: '15%'
        }}
      />

      {/* Grid Pattern */}
      <div
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)
          `,
          backgroundSize: '60px 60px'
        }}
      />

      {/* Noise Texture */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`
        }}
      />
    </div>
  );
};

export default AnimatedBackground;
